import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmUpload = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="icon-llm-upload" data-icon="icon-llm-upload" aria-hidden="true" {...props} ref={ref}><g clipPath="url(#clip0_469_4822)"><path d="M3.75 12H20.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 3.75V20.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/></g><defs><clipPath id="clip0_469_4822"><rect width="24" height="24" fill="currentColor"/></clipPath></defs></svg>);
});

IconLlmUpload.displayName = 'IconLlmUpload';
